import { Inject, Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { Sgkz012aRequest, SGKZ012AService } from 'sg-api';
import { catchError, map, timeout } from 'rxjs/operators';
import { SoshikiKenmuInfo } from '../components/sgkz007d/models/soshikiKenmuInfo.model';
import { SharedLibConfig } from '../config/shared-lib-config';
import { SHARED_LIB_CONFIG } from '../config/shared-lib-config.token';
import { ApiCommonService } from './api-common.service';
import { LoginUserIdService } from './login-user-id.service';

/**
 * 組織兼務画面表示用データ管理サービス
 * @export
 * @class UsedSgkz007aService
 */
@Injectable({
  providedIn: 'root'
})
export class UsedSgkz012aService {

  /** 二重呼び出し防止フラグ */
  public isCalledFlag = false;

  /** 組織兼務情報 */
  private _soshikiKenmuInfo$: BehaviorSubject<SoshikiKenmuInfo[]> = new BehaviorSubject<SoshikiKenmuInfo[]>([]);


  constructor(private injector: Injector,
    private sGKZ012AService: SGKZ012AService,
    private loginUserIdService: LoginUserIdService,
    @Inject(SHARED_LIB_CONFIG) private sharedLibConfig: SharedLibConfig) { }


  /**
   * 組織兼務情報を取得
   *
   * @return {*}  {SoshikiKenmuInfo[]}
   * @memberof UsedSgkz007aService
   */
  get soshikiKenmuInfo(): Observable<SoshikiKenmuInfo[]> {
    return this._soshikiKenmuInfo$.asObservable();
  }

  /**
   * 組織兼務情報を更新
   *
   * @return {*}  {string}
   * @memberof UsedSgkz011aService
   */
  set soshikiKenmuInfo(data: SoshikiKenmuInfo[]) {
    this._soshikiKenmuInfo$.next(data);
  }

  /**
   * 組織兼務情報を取得
   *
   * @return {*}  {string}
   * @memberof UsedSgkz011aService
   */
  public updateSoshikiKenmuInfo(): void {

    // 二重呼び出し防止
    this.isCalledFlag = true;

    // ユーザID更新
    let userId = '';
    this.loginUserIdService.loginUserId.subscribe(loginUserId => {
      userId = loginUserId;
    });

    let request: Sgkz012aRequest = {
      requestCommon: {},
      userId: userId
    };

    const apiCommonService = this.injector.get(ApiCommonService);
    this.sGKZ012AService.kz10RSGKZ012aPost(apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          apiCommonService.checkError(response);

          let soshikiKenmuInfoList: SoshikiKenmuInfo[] = [];
          for (const soshikiKenmuInfo of response.body.soshikiKenmuInfoList) {

            let soshikiKenmu: SoshikiKenmuInfo = {
              userId: soshikiKenmuInfo.ocHUsrId,
              organizationName: soshikiKenmuInfo.ocHSosikiName,
              companyName: soshikiKenmuInfo.ocYCmpnyName,
              userName: soshikiKenmuInfo.ocHUsrKanjiName
            };

            soshikiKenmuInfoList.push(soshikiKenmu);
          }

          this._soshikiKenmuInfo$.next(soshikiKenmuInfoList);
        }),

        timeout(Number(this.sharedLibConfig.httpTimeout)),
        catchError((err) => {
          return throwError(err);
        }))
      .subscribe();
  }
}
